<template>
  <v-dialog
    v-model="sysalert"
    hide-overlay
    persistent
    width="300"
  >
    <v-alert type="success">
    {{sysalertText}}
    </v-alert>      
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
    name: 'system-alert',
    props: { 
      sysalertText: {
            default: ''
      }, 
      sysalertTitle: {
            default: ''
      }, 
      sysalert: {
            default: false
      }
    },
    data () {
      return {
        mini: false,
        isRootComponent: true,
        // clipped: false,
        drawer: true,
        fixed: false
      }
    },
    methods: {
      onConfirm () {}      
    },
    mounted () {      
    }
  }
</script>
